import {
  NOTIFICATIONS_GET_ALL_REQUEST,
  NOTIFICATIONS_GET_ALL_SUCCESS,
  NOTIFICATIONS_GET_ALL_FAILURE,
  NOTIFICATIONS_MARK_AS_READ_REQUEST,
  NOTIFICATIONS_MARK_AS_READ_SUCCESS,
  NOTIFICATIONS_MARK_AS_READ_FAILURE,
  NOTIFICATIONS_MARK_ALL_AS_READ_REQUEST,
  NOTIFICATIONS_MARK_ALL_AS_READ_SUCCESS,
  NOTIFICATIONS_MARK_ALL_AS_READ_FAILURE,
} from '../../actions/actionTypes';

import { SUCCESS, FAILED, PENDING, REQUESTING } from '../../actions/statusTypes';

const INITIAL_STATE = {
  errorMessage: '',
  fetchStatus: PENDING,
  clearStatus: PENDING,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case NOTIFICATIONS_GET_ALL_REQUEST:
      return {
        ...state,
        fetchStatus: REQUESTING,
        clearStatus: PENDING,
        errorMessage: '',
      };
    case NOTIFICATIONS_MARK_ALL_AS_READ_REQUEST:
      return {
        ...state,
        clearStatus: REQUESTING,
        fetchStatus: PENDING,
        errorMessage: '',
      };
    case NOTIFICATIONS_GET_ALL_SUCCESS:
      return { ...state, fetchStatus: SUCCESS, errorMessage: '' };
    case NOTIFICATIONS_MARK_ALL_AS_READ_SUCCESS:
      return { ...state, clearStatus: SUCCESS, errorMessage: '' };
    case NOTIFICATIONS_GET_ALL_FAILURE:
      return { ...state, fetchStatus: FAILED, errorMessage: '' };
    case NOTIFICATIONS_MARK_ALL_AS_READ_FAILURE:
      return { ...state, clearStatus: FAILED, errorMessage: '' };
  }

  return state;
}
